export default "__VITE_ASSET__DUDeqJJC__"